import { parseEnumFilter, parseTextFilter, toFilterText } from '@/utils/filters';
import { SURVEY_STATUS, type SurveyStatus } from '../types/survey.types';

type FilterValues = Record<string, string>;

interface SurveyFilterSearch {
  state?: SurveyStatus | undefined;
  from?: string | undefined;
  to?: string | undefined;
}

export function toSurveyFilterValues(search: SurveyFilterSearch): FilterValues {
  return {
    state: toFilterText(search.state),
    from: toFilterText(search.from),
    to: toFilterText(search.to),
  };
}

export function toSurveyFilterSearch(values: FilterValues): SurveyFilterSearch {
  return {
    state: parseEnumFilter(values.state, SURVEY_STATUS),
    from: parseTextFilter(values.from),
    to: parseTextFilter(values.to),
  };
}
